import { render } from "./InspectionDetail.vue?vue&type=template&id=a3681ec2"
import script from "./InspectionDetail.vue?vue&type=script&lang=js"
export * from "./InspectionDetail.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__